import { PageHead } from "@generalapplications/html-render/react";
import { EmptyState, PageArticle, Stack } from "@generalapplications/ui";
import {
  isRouteErrorResponse,
  Link,
  useLocation,
  useRouteError,
} from "react-router-dom";
import { articleLoadError } from "@/content/blog";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { NotFoundPage } from "@/app/pages/notFound/NotFoundPage";

export function BlogRouteError() {
  const error: unknown = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404)
    return <NotFoundPage />;
  return <ArticleLoadFailure />;
}

function ArticleLoadFailure() {
  const { pathname } = useLocation();
  const head = pageHead({
    path: pathname,
    title: articleLoadError.title,
    description: articleLoadError.description,
    noIndex: true,
  });
  return (
    <PageArticle width="lg" centered>
      <PageHead head={head} />
      <Stack role="alert">
        <EmptyState
          titleAs="h1"
          title={articleLoadError.title}
          description={articleLoadError.description}
        >
          {/* A whole-document reload: the loader failed, so a client
              navigation to the same route would replay the same failure. */}
          <Link to={pathname} reloadDocument>
            {articleLoadError.retry}
          </Link>
        </EmptyState>
      </Stack>
    </PageArticle>
  );
}
